// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7513e899","455":"4a26ed35","977":"e9835c21"}[chunkId] + ".chunk.js";
};